var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34,
    viewBox: "0 0 52 34",
    width: 52,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h52v34h-52z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.722 21.163h-13.954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2534.682 1108.289h-2a1.276 1.276 0 0 1 -1.141-.705l-.5-1.01a5.094 5.094 0 0 1 -.538-2.279v-.045a5.089 5.089 0 0 1 .856-2.826l1.935-2.9c.236-.473.867-1.4 1.4-1.4h14.771a1.4 1.4 0 0 1 .986.408l3.449 3.468a1.4 1.4 0 0 0 .758.39l6.536 1.321a1.641 1.641 0 0 1 1.4 1.4v2.911a1.275 1.275 0 0 1 -1.275 1.275h-1.519",
    transform: "translate(-2520.495 -1087.126)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.978,
    cy: 21.163,
    r: 2.791
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.513,
    cy: 21.163,
    r: 2.791
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.75bc0d2d90d24279089886607b43ca8c.svg";
export { ForwardRef as ReactComponent };